import { Component, Inject, OnInit, OnDestroy, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettingService, AppUtilityService } from '../../app.service';
import { Location } from '@angular/common';
import { UserInfoService } from '../user-info.service';
import { UserAPIService, NewAnonymousUser } from '../user-api.service';
import { AnonymousUserService } from './anonymous-user.service';

@Component({
	selector: "app-anonymous-user-welcome",
	template: "",
	standalone: false
})
export class AnonymousUserWelcomeComponent implements OnInit, OnDestroy {
	@Input() requestFrom: string = "interest";
	@Input() isPrior: boolean = true;
	@Output() onClose: EventEmitter<string> = new EventEmitter();

	constructor(
		private userInfo: UserInfoService,
		private dialog: MatDialog,
		private anonymousSrv: AnonymousUserService
	) { }

	anonymousUserPopup: any = null;
	showMinimize = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event'])
	onResize(event: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	private closeLogin = () => {
		if (this.onClose != undefined) {
			this.onClose.emit("");
		}
	}

	private askLogin(email: any) {
		this.anonymousSrv.openSignupLogin('login', '', false, email, this.closeLogin);
	}

	ngOnDestroy(): void {
		// in case users use browser go back
		if (this.anonymousUserPopup != null) {
			this.anonymousUserPopup.close({ action: 'cancel' });
		}
	}

	private askInfo() {
		if (this.anonymousUserPopup != null) {
			return;
		}
		var modalSize = {
			width: "90%",
			maxWidth: "850px",
			height: "unset"
		}
		if (this.showMinimize) {
			modalSize.width = "100%";
			modalSize.height = "100%";
			modalSize.maxWidth = "100%";
		}

		this.anonymousUserPopup = this.dialog.open(
			AnonymousUserWelcomeDialog,
			{
				maxWidth: modalSize.maxWidth,
				width: modalSize.width,
				height: modalSize.height,
				disableClose: false,
				autoFocus: true,
				panelClass: 'jmDialog',
				data: {
					requestFrom: this.requestFrom,
					isPrior: this.isPrior,
					showMinimize: this.showMinimize
				}
			}
		);

		this.anonymousUserPopup.afterClosed().subscribe({
			next: (choice: any) => {
				if (choice.action === 'hasAccount') {
					this.askLogin(choice.email);
				}
				else {
					this.onClose.emit(choice);
				}
			},
			error: (err: any) => {
				console.log(err);
				this.onClose.emit(err);
			}
		});
	}

	ngOnInit(): void {
		this.requestFrom = this.requestFrom !== 'interest' && this.requestFrom !== 'skills' ? 'interest' : this.requestFrom;
		if (this.userInfo.isLogin() && this.userInfo.isAnonymous()) {
			if (this.userInfo.anonymousEmail === "") {
				setTimeout(() => { this.askInfo(); }, 500);
			}
			else {
				this.onClose.emit("");
			}

		}
		else {
			this.onClose.emit("");
		}
	}
}


@Component({
	templateUrl: "./anonymous-user-welcome.dialog.html",
	styleUrls: ["../signupLogin/login.scss"],
	standalone: false
})
export class AnonymousUserWelcomeDialog implements OnInit {
	requestFrom: string = "";
	isPrior: boolean = true;
	showMinimize: boolean = false;
	processing: boolean = false;
	errorType: number = 0;

	constructor(
		private userInfo: UserInfoService,
		private UserAPI: UserAPIService,
		private dialogRef: MatDialogRef<AnonymousUserWelcomeDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.requestFrom = data?.requestFrom ?? "";
		this.isPrior = data?.isPrior ?? true;
		this.showMinimize = data?.showMinimize ?? false;
	}

	close(e: any): void {
		this.dialogRef.close();
	}

	newAnonymousUser = new NewAnonymousUser();

	cancel(e: any) {
		this.dialogRef.close({ action: 'cancel' });
	};

	checkUser(e: any) {
		this.errorType = 0;
		this.newAnonymousUser.Email = this.newAnonymousUser.Email.trim();

		if (this.newAnonymousUser.Email === '') {
			this.newAnonymousUser.EmailStatus = null;
			return;
		}

		if (e.type == null || (e.type !== 'click' && e.type !== 'keyup') || (e.type === 'keyup' && e.keyCode !== 13)) {
			return;
		}

		if (!AppUtilityService.isEmail(this.newAnonymousUser.Email)) {
			this.newAnonymousUser.EmailStatus = false;
			this.errorType = 1;
			return;
		}
		else {
			this.newAnonymousUser.EmailStatus = true;
		}

		this.processing = true;
		// check if email exist as username
		this.UserAPI.checkUserNameExist(this.newAnonymousUser.Email, '').subscribe({
			next: (response: any) => {
				this.newAnonymousUser.EmailStatus = !response.AccountExist;
				if (response.AccountExist) {
					this.processing = false;
					this.dialogRef.close({ action: 'hasAccount', email: this.newAnonymousUser.Email });
				}
				else {
					this.UserAPI.saveAnonymousUser(this.newAnonymousUser).subscribe({
						next: (rep: any) => {
							this.userInfo.anonymousEmail = this.newAnonymousUser.Email;
							this.dialogRef.close({ action: 'close' });
						},
						error: (err: any) => {
							console.log(err);
							this.errorType = 3;
						}
					});
				}
			},
			error: (err: any) => {
				console.log(err);
				this.processing = false;
			}
		});

	};

	ngOnInit(): void {
		this.newAnonymousUser.InstitutionCode = this.userInfo.getInstitutionCode();
	}
}


@Component({
	templateUrl: './anonymous-data-transfer.component.html',
	standalone: false
})
export class AnonymousDataTransferComponent {
	anonymousUserLink: string = "";
	uiType: number = 0;

	constructor(
		private activeRoute: ActivatedRoute,
		private location: Location,
		private router: Router,
		private userAPI: UserAPIService,
		private userInfo: UserInfoService
	) { }

	close(e: any): void {
		if (!this.userInfo.isAnonymous()) {
			this.router.navigateByUrl("/User/ProfileDashboard");
		}
		else {
			window.location.href = AppSettingService.baseUrl + "/User/Login";
		}
	}

	ngOnInit(): void {
		this.anonymousUserLink = (this.activeRoute.snapshot.paramMap.get("anonymousUserLink") ?? "").trim();

		if (this.anonymousUserLink !== '') {
			this.location.replaceState("/User/AnonymousDataTransfer/");
		}

		if (this.anonymousUserLink === '') {
			this.uiType = 8;
		}
		else {
			this.userAPI.transferAnonymousUserData(this.anonymousUserLink).subscribe({
				next: (response: any) => {
					let transfer = response;
					this.userInfo.clearStorage();
					// relay 3 seconds to get cookie populate first and then do redirection
					setTimeout(
						() => {
							if (transfer.WasTransferred) {
								this.uiType = 2;
							}
							else {
								this.uiType = 1;
							}

							if (this.uiType === 1 && !this.userInfo.isAnonymous()) {
								if (transfer.HasInterest) {
									window.location.href = AppSettingService.baseUrl +"/InterestSurvey/Result";
								}
								else if (transfer.HasInterest) {
									window.location.href = AppSettingService.baseUrl + "/SkillProfiler/Result";
								}
								else {
									window.location.href = "/User/ProfileDashboard";
								}
							}
							// has transferred before, pause the screen; else send user to journey home site
							else if (this.uiType !== 2) {
								window.location.href = AppSettingService.baseUrl + "/User/Login";
							}
						}, 3000
					);
				},
				error: (err: any) => {
					console.log(err);
					this.uiType = 7;
				}
			});
		}
	}
}
